import ReactIntlProvider from './ReactIntlProvider';

export default ReactIntlProvider;
